import css from 'styled-jsx/css';
import { colors } from '../../../../themes/index';

export default css`
  .list {
    background: ${colors.grayExtraLight};
    padding: 1px 0;
  }

  h6 {
    color: ${colors.grayDeep};
    margin: 20px 10px 20px;
    font-size: 1em; /* 16/16 */
    font-weight: bold;
    text-shadow: 0 1px 0 #fff;
  }

  .fetching {
    opacity: 0.5;
  }

  .hide {
    display: none;
  }

  .dfp {
    padding: 6px 0 6px;
    text-align: center;
  }

  .dfp :global(iframe) {
    display: block;
    margin: auto;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/ListAds/styles.js